// extracted by mini-css-extract-plugin
module.exports = {"main":"Tabs_main__2v0WL","active":"Tabs_active__3zdew"};